module.exports = __webpack_public_path__ + "img/Ident-Process-2-mobile.79aee427.png";